import Backbone from 'backbone'
import ObjectSelector from 'scoreboard/components/object-selector'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'
import TreeActions from 'scoreboard/components/tree-actions'
import metadata from 'scoreboard/components/metadata'
import license from 'scoreboard/components/license'
import config from 'scoreboard/components/config'

var MenuOption = Backbone.View.extend({
	className: 'object-selector-menu-option',

	initialize: function (opt) {
		this.section = opt.section
		this.canvas = opt.canvas
		this.bootslideMenu = opt.bootslideMenu

		let options = this.selectorOptions()
		options.preventStandardExpand = true
		this.objectSelector = new ObjectSelector(options)
	},

	selectorOptions: function (opt) {
	},

	buttonLabelCode: 'common.add',

	render: function () {
		this.$el.addClass(this.section)
		this.objectSelector.render()

		// The object selector breaks the tooltip's animation of height/width.
		// Wait until the transition is done to append it (but we can start
		// rendering right away)
		this.on('transitioned', _.bind(function () {
			this.$el.append(this.objectSelector.el)
			// Render tree-action button if org is already selected on load,
			this.addTreeAction()

			let singleTreeSelector = this.objectSelector.$el.hasClass('single-tree-selector')
			// If there is only one tree in the menu, use the gardener element since there may
			// not be a container specific to the type of selector
			let types = singleTreeSelector ? ['gardener'] : ['org', 'object']
			this.bootslideMenu.setTreeWidths({
				el: this.$el,
				gardeners: this.objectSelector.orgGardener ? [this.objectSelector.orgGardener, this.objectSelector.objectGardener] : [this.objectSelector.objectGardener],
				types
			})
		}.bind(this)))
		return this
	},

	addTreeAction: function() {
		this.treeActions = new TreeActions({
			el: this.objectSelector.objectGardener.el,
			tree: this.objectSelector.objectGardener.tree,
			buttonContent: i18n.get(this.buttonLabelCode),
			nodesReselectable: true
		}).render()
		this.treeActions.on('treeActionReset', () => this.checkPermissions())
			.on('nodeActivated', node => this.checkPermissions(node))
			.on('selected', id => this.select(this.objectSelector.objectGardener.tree.get(id)))
		this.objectSelector.on('search', this.treeActions.onSearch.bind(this.treeActions))
		// Update the tree whenever a new org is chosen.
		this.objectSelector.on('success', () => this.treeActions.setTree(this.objectSelector.objectGardener.tree))
	},

	select: function (node) {
	},

	/**
	 * Disables the "Add" button on the node if it shouldn't actually be selectable
	 */
	checkPermissions: function(treeNode) {
		treeNode = treeNode || this.$('.object .node.selected')

		if (!treeNode) {
			return
		}

		var node = this.objectSelector.objectGardener.tree.get(treeNode.data('id'))
		var allowSelect = this.allowSelect(node)
		treeNode.find('.label-mask').toggleClass('is-disabled', !allowSelect)
	},

	/**
	 * Method that can be overridden to disable selection of specific nodes
	 */
	allowSelect: function (node) {
		// If node doesn't have a checkmark, it can be added
		return !this.$(`.node[data-id="${node.id}"] .label-mask`).hasClass('is-checked')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.treeActions], 'remove')
		this.objectSelector && this.objectSelector.remove()
	}
})

// Builds a bootslide submenu for selecting domain objects. Builds
// an option for each section, each of which leads to an appropriate
// object-selector
var menu = function (bootslideMenu, topLabel, OptionClass, SectionLabelClass, sections) {
	SectionLabelClass = SectionLabelClass || SectionLabel

	function selectObjectTarget (label, svg, section) {
		return {
			id: section,
			label: i18n.get(label),
			contentView: SectionLabelClass.extend({ svgIcon: svg, label: label, section: section }),
			contentEndpoint: sectionEndpoint(bootslideMenu, section, OptionClass)
		}
	}

	var sectionFilter = sections ? function (section) { return _.includes(sections, section) } : _.constant(true)

	// #16346 #15211 do not show menu items for sections that are not enabled
	var securedPossibleSections = securePossibleSections(possibleSections)

	return {
		label: i18n.get(topLabel),
		width: 200,
		target: securedPossibleSections.filter(sectionFilter).map(function (section) {
			var meta = metadata[section]
			var code = section === 'scorecards' ? 'scorecards.scorecardNode' : meta.singularCode

			return selectObjectTarget(code, meta.sectionIcon, section)
		})
	}
}

var possibleSections = ['scorecards', 'initiatives', 'strategyMaps', 'dashboards', 'reports', 'charts', 'briefings', 'datasets', 'files', 'forms' ]

var SectionLabel = Backbone.View.extend({
	render: function () {
		let html = '<span class="icon-container">' +
			icon(this.svgIcon, 'option-icon') +
			'</span>' +
			`<span class="option-label">${i18n.get(this.label)}</span>`
		this.$el.html(html)
		return this
	}
})

function sectionEndpoint (bootslideMenu, section, OptionClass) {
	return _.bind(function () {
		var v = new OptionClass({
			model: this.model,
			section,
			canvas: bootslideMenu.canvas,
			bootslideMenu
		})

		this.$('.bootslide-container').one('transitionend', function () {
			v.trigger('transitioned')
		})

		this.childViews.push(v)

		v.on('back', this.back.bind(this))

		return v.render().el
	}, bootslideMenu)
}

function securePossibleSections(possibleSections) {
	// note: with #48947, license.forms is based on license.datasets
	let sections = _.filter(possibleSections, (section) => license[section] != false)
	if (!config.displayStrategyMaps) {
		_.pull(sections, 'strategyMaps')
	}
	return sections
}

menu.Option = MenuOption
menu.SectionLabel = SectionLabel

export default menu
export { sectionEndpoint }
export { possibleSections }

menu.__filename__ = 'components/bootslide/object-selector-menu.js'
